import React from 'react';
import Box from '@material-ui/core/Box';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { When } from 'UI/components/atoms';
import CollapsiblePanel from 'UI/components/templates/CollapsiblePanel';
import ContentPageLayout from 'UI/components/templates/ContentPageLayout';

import { useResponsiveFilterLayoutStyles } from './ResponsiveFilterLayout.styled';

export const ResponsiveFilterLayout = ({
  leftPanel,
  rightPanel,
  isFloatingPanelOpen,
  onToggleFloatingPanel,
  slotProps
}) => {
  const isLargeScreen = useMediaQuery(({ breakpoints }) => breakpoints.up('lg'));
  const classes = useResponsiveFilterLayoutStyles({ isLargeScreen });
  const isSideMenuOpen = !isLargeScreen && isFloatingPanelOpen;

  return (
    <>
      <ContentPageLayout mode="customLayout">
        <Box className={classes.mainGrid}>
          <Box className={classes.leftPanel}>{leftPanel}</Box>
          <Box className={classes.rightPanel}>{rightPanel}</Box>
        </Box>
      </ContentPageLayout>
      <When condition={!isLargeScreen}>
        <CollapsiblePanel
          isSideMenuOpen={isSideMenuOpen}
          mode="overlay"
          onToggle={onToggleFloatingPanel}
          {...slotProps?.collapsiblePanel}
        >
          {!isLargeScreen && isSideMenuOpen && leftPanel}
        </CollapsiblePanel>
      </When>
    </>
  );
};
